import React, { useState } from 'react';
import ProjectLocationsMap from '../../components/ProjectLocationsMap/ProjectLocationsMap';
import EnergyFinancingChart from '../../components/EnergyFinancingChart/EnergyFinancingChart';
import HouseholdElectrificationChart from '../../components/HouseholdElectrificationChart/HouseholdElectrificationChart';
import ProjectDatabaseTable from '../../components/ProjectDatabaseTable/ProjectDatabaseTable';
import './CountryEnergyProfileV1.scss';

const CountryEnergyProfileV1 = () => {
  const [selectedCountry, setSelectedCountry] = useState('All Countries');
  const [selectedInstitution, setSelectedInstitution] = useState('All Institutions');
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showInstitutionDropdown, setShowInstitutionDropdown] = useState(false);

  const countries = ['All Countries', 'Kenya', 'Morocco', 'Nigeria', 'South Africa', 'Egypt'];
  const institutions = ['All Institutions', 'World Bank', 'AfDB', 'Other IFIs'];

  const handleExportData = () => {
    // Create a simple CSV export functionality
    const csvContent = "data:text/csv;charset=utf-8," + 
      "Project Name,Country,Sector,Investment,Impact,Status\n" +
      "BrightSun Initiative,Kenya,Solar Energy,$10M,100000 homes,Active\n" +
      "Rural Electrification Project,Uganda,Grid Extension,$5M,50000 homes,Completed\n" +
      "Clean Cookstove Initiative,Nigeria,Clean Cooking,$2M,200000 households,Active\n" +
      "Hydro Power Development,Rwanda,Renewable Energy,$20M,20000 homes,Active\n" +
      "Wind Energy Project,Ethiopia,Wind Energy,$15M,150000 homes,Completed";
    
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "africa_energy_projects_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="data-dashboard-page">
      <div className="dashboard-header">
        <div className="header-content">
          <h1 className="dashboard-title">Data Dashboard</h1>
          <p className="dashboard-subtitle">Explore energy access and clean energy finance data across Africa</p>
        </div>
        <div className="global-filters">
          <div className="dropdown-container">
            <button 
              className="filter-btn dropdown-btn"
              onClick={() => {
                setShowCountryDropdown(!showCountryDropdown);
                setShowInstitutionDropdown(false);
              }}
            >
              {selectedCountry}
              <span className="dropdown-arrow">▼</span>
            </button>
            {showCountryDropdown && (
              <div className="dropdown-menu">
                {countries.map(country => (
                  <button
                    key={country}
                    className={`dropdown-item ${selectedCountry === country ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedCountry(country);
                      setShowCountryDropdown(false);
                    }}
                  >
                    {country}
                  </button>
                ))}
              </div>
            )}
          </div>
          
          <div className="dropdown-container">
            <button 
              className="filter-btn dropdown-btn"
              onClick={() => {
                setShowInstitutionDropdown(!showInstitutionDropdown);
                setShowCountryDropdown(false);
              }}
            >
              {selectedInstitution}
              <span className="dropdown-arrow">▼</span>
            </button>
            {showInstitutionDropdown && (
              <div className="dropdown-menu">
                {institutions.map(institution => (
                  <button
                    key={institution}
                    className={`dropdown-item ${selectedInstitution === institution ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedInstitution(institution);
                      setShowInstitutionDropdown(false);
                    }}
                  >
                    {institution}
                  </button>
                ))}
              </div>
            )}
          </div>
          
          <button className="filter-btn export-btn" onClick={handleExportData}>
            📥 Export Data
          </button>
        </div>
      </div>
      
      <div className="dashboard-grid">
        <div className="dashboard-row-1">
          <div className="map-section">
            <ProjectLocationsMap />
          </div>
        </div>
        
        <div className="dashboard-row-2">
          <div className="chart-section">
            <EnergyFinancingChart />
          </div>
          <div className="chart-section">
            <HouseholdElectrificationChart />
          </div>
        </div>
        
        <div className="dashboard-row-3">
          <ProjectDatabaseTable />
        </div>
      </div>
    </div>
  );
};

export default CountryEnergyProfileV1;


